import type { AttendanceCorrectionRequestFilters } from '../types/attendanceCorrection';
import type { AttendanceHistoryFilters } from '../types/attendance';
import type {
  LeaveApplicationSummaryParams,
  LeaveHistoryFilters,
} from '../types/leave';
import type { LeaveConfiguration } from '../types/leaveConfiguration';
import type { SafeReportFilterState } from '../types/report';
import type { TimePermissionRequestFilters } from '../types/timePermission';
import type { WfhRequestFilters } from '../types/wfh';
import type { WorkflowInboxFilters } from '../types/workflow';

export const routes = {
  splash: 'Splash',
  auth: 'Auth',
  login: 'Login',
  forgotPassword: 'ForgotPassword',
  kiosk: 'Kiosk',
  mainTabs: 'MainTabs',
  dashboard: 'Dashboard',
  adminDashboard: 'AdminDashboard',
  teamDashboard: 'TeamDashboard',
  attendance: 'Attendance',
  attendanceHistory: 'AttendanceHistory',
  attendanceFilter: 'AttendanceFilter',
  attendanceDetails: 'AttendanceDetails',
  locationTrackingDetails: 'LocationTrackingDetails',
  employees: 'Employees',
  employeeList: 'Employees',
  employeeDetails: 'EmployeeDetails',
  employeeTimeOffBalance: 'EmployeeTimeOffBalance',
  employeeEdit: 'EmployeeEdit',
  employeeFilter: 'EmployeeFilter',
  employeeFaceRegistration: 'EmployeeFaceRegistration',
  employeeAssignShift: 'EmployeeAssignShift',
  employeeCreate: 'EmployeeCreate',
  faceEnrollmentCamera: 'FaceEnrollmentCamera',
  faceIdentify: 'FaceIdentify',
  faceAdmin: 'FaceAdmin',
  leave: 'Leave',
  leaveApplications: 'LeaveApplications',
  leaveFilter: 'LeaveFilter',
  leaveDetails: 'LeaveDetails',
  adminLeaveRequests: 'AdminLeaveRequests',
  leaveApproval: 'LeaveApproval',
  leaveConfigurationList: 'LeaveConfigurationList',
  leaveConfigurationCreate: 'LeaveConfigurationCreate',
  leaveBalanceList: 'LeaveBalanceList',
  leaveBalanceEmployee: 'LeaveBalanceEmployee',
  leaveBalanceUpdate: 'LeaveBalanceUpdate',
  wfhConfigurationList: 'WfhConfigurationList',
  wfhConfigurationCreate: 'WfhConfigurationCreate',
  permissionConfigurationList: 'PermissionConfigurationList',
  permissionConfigurationCreate: 'PermissionConfigurationCreate',
  permissionConfigurationPolicy: 'PermissionConfigurationPolicy',
  lateArrivalConfiguration: 'LateArrivalConfiguration',
  wfhHome: 'WfhHome',
  wfhRequests: 'WfhRequests',
  wfhFilter: 'WfhFilter',
  wfhDetails: 'WfhDetails',
  adminWfhRequests: 'AdminWfhRequests',
  wfhApproval: 'WfhApproval',
  timePermissionHome: 'TimePermissionHome',
  timePermissionRequests: 'TimePermissionRequests',
  timePermissionFilter: 'TimePermissionFilter',
  timePermissionDetails: 'TimePermissionDetails',
  adminTimePermissionRequests: 'AdminTimePermissionRequests',
  timePermissionApproval: 'TimePermissionApproval',
  attendanceCorrectionHome: 'AttendanceCorrectionHome',
  attendanceCorrectionRequests: 'AttendanceCorrectionRequests',
  attendanceCorrectionFilter: 'AttendanceCorrectionFilter',
  attendanceCorrectionDetails: 'AttendanceCorrectionDetails',
  adminAttendanceCorrectionRequests: 'AdminAttendanceCorrectionRequests',
  attendanceCorrectionApproval: 'AttendanceCorrectionApproval',
  workflowInbox: 'WorkflowInbox',
  workflowFilter: 'WorkflowFilter',
  workflowDetails: 'WorkflowDetails',
  notificationList: 'NotificationList',
  notificationDetails: 'NotificationDetails',
  notificationPreferences: 'NotificationPreferences',
  reportList: 'ReportList',
  reportFilter: 'ReportFilter',
  reportPreview: 'ReportPreview',
  reportDownloadResult: 'ReportDownloadResult',
  attendanceReport: 'AttendanceReport',
  teamAttendanceReport: 'TeamAttendanceReport',
  monthlyAttendanceReport: 'MonthlyAttendanceReport',
  weeklyAttendanceReport: 'WeeklyAttendanceReport',
  employeeOverallWeeklyReport: 'EmployeeOverallWeeklyReport',
  employeeMonthlyAttendanceReport: 'EmployeeMonthlyAttendanceReport',
  weeklyAttendanceEmployee: 'WeeklyAttendanceEmployee',
  myWeeklyAttendance: 'MyWeeklyAttendance',
  wfhReport: 'WfhReport',
  leaveReport: 'LeaveReport',
  organizationHome: 'OrganizationHome',
  organizationDetails: 'OrganizationDetails',
  organizationEdit: 'OrganizationEdit',
  organizationList: 'OrganizationList',
  organizationCreate: 'OrganizationCreate',
  organizationCreated: 'OrganizationCreated',
  managedOrganizationDetails: 'ManagedOrganizationDetails',
  organizationHrAdminCreate: 'OrganizationHrAdminCreate',
  locationList: 'LocationList',
  locationDetails: 'LocationDetails',
  locationCreate: 'LocationCreate',
  locationEdit: 'LocationEdit',
  departmentList: 'DepartmentList',
  departmentDetails: 'DepartmentDetails',
  departmentCreate: 'DepartmentCreate',
  departmentEdit: 'DepartmentEdit',
  designationList: 'DesignationList',
  designationDetails: 'DesignationDetails',
  designationCreate: 'DesignationCreate',
  designationEdit: 'DesignationEdit',
  teamList: 'TeamList',
  teamDetails: 'TeamDetails',
  teamCreate: 'TeamCreate',
  teamEdit: 'TeamEdit',
  shiftList: 'ShiftList',
  shiftDetails: 'ShiftDetails',
  shiftCreate: 'ShiftCreate',
  shiftEdit: 'ShiftEdit',
  workPolicyList: 'WorkPolicyList',
  workPolicyDetails: 'WorkPolicyDetails',
  workPolicyCreate: 'WorkPolicyCreate',
  workPolicyEdit: 'WorkPolicyEdit',
  menu: 'Menu',
  apiStatus: 'ApiStatus',
  profile: 'Profile',
  profileDetails: 'ProfileDetails',
  settings: 'Settings',
  about: 'About',
  changePassword: 'ChangePassword',
  unauthorized: 'Unauthorized',
  kioskList: 'KioskList',
  kioskCreate: 'KioskCreate',
  kioskDetails: 'KioskDetails',
  kioskActivationQr: 'KioskActivationQr',
  kioskActivation: 'KioskActivation',
  projectList: 'ProjectList',
  projectCreate: 'ProjectCreate',
  projectEdit: 'ProjectEdit',
  projectTaskBoard: 'ProjectTaskBoard',
  projectTaskDetails: 'ProjectTaskDetails',
  projectReport: 'ProjectReport',
  visitorList: 'VisitorList',
  visitorRegister: 'VisitorRegister',
  visitorCheckIn: 'VisitorCheckIn',
  visitorCheckOut: 'VisitorCheckOut',
  visitorHistory: 'VisitorHistory',
  officeCalendar: 'OfficeCalendar',
  holidayCalendarList: 'HolidayCalendarList',
  holidayCalendarCreate: 'HolidayCalendarCreate',
  holidayCalendarEdit: 'HolidayCalendarEdit',
  /** Bottom-tab route for employee office calendar (same screen, distinct nav name). */
  calendarTab: 'CalendarTab',
} as const;

export type RootStackParamList = {
  Splash: undefined;
  Auth: undefined;
  Kiosk: undefined;
  MainTabs: undefined;
  Dashboard: undefined;
  AdminDashboard: undefined;
  /** Team Lead dashboard — HR Admin layout scoped to assigned employees. */
  TeamDashboard: undefined;
  ApiStatus: undefined;
  ChangePassword: undefined;
  Unauthorized: undefined;
  Profile: undefined;
  ProfileDetails: undefined;
  Settings: undefined;
  LateArrivalConfiguration: undefined;
  About: undefined;
  EmployeeDetails: { employeeId: number };
  EmployeeTimeOffBalance: { employeeId: number };
  EmployeeEdit: { employeeId: number };
  EmployeeFaceRegistration: { employeeId: number };
  EmployeeAssignShift: { employeeId: number };
  EmployeeCreate: undefined;
  FaceEnrollmentCamera: { employeeId: number; guidanceLabel?: string };
  FaceIdentify: undefined;
  FaceAdmin: undefined;
  AttendanceHistory:
    | {
        appliedFilters?: AttendanceHistoryFilters;
        /** When set (e.g. from Employee Details), load that employee's history. */
        employeeId?: number;
      }
    | undefined;
  AttendanceFilter: {
    currentFilters: AttendanceHistoryFilters;
  };
  // Backend details API is keyed by attendanceDate (YYYY-MM-DD), not attendanceId.
  AttendanceDetails: {
    attendanceDate: string;
    /** When set, load details for that employee instead of the signed-in user. */
    employeeId?: number;
  };
  /** Live/historical location tracking for one attendance (client visits). */
  LocationTrackingDetails: { attendanceId: number };
  LeaveApplications:
    | {
        appliedFilters?: LeaveHistoryFilters;
      }
    | undefined;
  LeaveFilter: {
    currentFilters: LeaveHistoryFilters;
  };
  // No dedicated leave-details API; summary-only params (no reason/contact).
  LeaveDetails: LeaveApplicationSummaryParams;
  /** Admin leave request list — LEAVE_APPROVE only. */
  AdminLeaveRequests:
    | {
        compensatoryWorkRequestId?: number;
      }
    | undefined;
  /** Admin leave approval — LEAVE_APPROVE only; keyed by workflow instance. */
  LeaveApproval: {
    workflowInstanceId: number;
  };
  LeaveConfigurationList: undefined;
  LeaveConfigurationCreate: { configuration?: LeaveConfiguration } | undefined;
  LeaveBalanceList: undefined;
  LeaveBalanceEmployee: { employeeId: number; leaveYear?: number };
  LeaveBalanceUpdate: {
    employeeId: number;
    leaveTypeId: number;
    leaveYear: number;
  };
  WfhConfigurationList: undefined;
  WfhConfigurationCreate: { wfhPolicyId?: number } | undefined;
  PermissionConfigurationList: undefined;
  PermissionConfigurationCreate: undefined;
  PermissionConfigurationPolicy: undefined;
  WfhHome: undefined;
  WfhRequests:
    | {
        appliedFilters?: WfhRequestFilters;
      }
    | undefined;
  WfhFilter: {
    currentFilters: WfhRequestFilters;
  };
  // Dedicated GET /wfh/:wfhRequestId is mounted; pass ID only.
  WfhDetails: {
    wfhRequestId: number;
  };
  /** Admin WFH request list — WFH_APPROVE only. */
  AdminWfhRequests: undefined;
  /** Admin WFH approval — WFH_APPROVE only; keyed by workflow instance. */
  WfhApproval: {
    workflowInstanceId: number;
  };
  TimePermissionHome: undefined;
  TimePermissionRequests:
    | {
        appliedFilters?: TimePermissionRequestFilters;
      }
    | undefined;
  TimePermissionFilter: {
    currentFilters: TimePermissionRequestFilters;
  };
  // Dedicated GET /permissions/:permissionRequestId is mounted; pass ID only.
  TimePermissionDetails: {
    permissionRequestId: number;
  };
  /** Admin permission request list — PERMISSION_APPROVE only. */
  AdminTimePermissionRequests: undefined;
  /** Admin permission approval — PERMISSION_APPROVE only; keyed by workflow instance. */
  TimePermissionApproval: {
    workflowInstanceId: number;
  };
  AttendanceCorrectionHome:
    | {
        initialAttendanceDate?: string;
      }
    | undefined;
  AttendanceCorrectionRequests:
    | {
        appliedFilters?: AttendanceCorrectionRequestFilters;
      }
    | undefined;
  AttendanceCorrectionFilter: {
    currentFilters: AttendanceCorrectionRequestFilters;
  };
  AttendanceCorrectionDetails: {
    correctionRequestId: number;
  };
  AdminAttendanceCorrectionRequests: undefined;
  AttendanceCorrectionApproval: {
    workflowInstanceId: number;
  };
  WorkflowInbox:
    | {
        appliedFilters?: WorkflowInboxFilters;
      }
    | undefined;
  WorkflowFilter: {
    currentFilters: WorkflowInboxFilters;
  };
  WorkflowDetails: {
    workflowInstanceId: number;
  };
  NotificationList: undefined;
  // Details API is not mounted; ID-only route for mark-read / future use.
  NotificationDetails: {
    notificationId: number;
  };
  NotificationPreferences: undefined;
  ReportList: undefined;
  ReportFilter: {
    reportCode: string;
  };
  ReportPreview: {
    reportCode: string;
    filters: SafeReportFilterState;
  };
  ReportDownloadResult: {
    downloadId: string;
  };
  AttendanceReport:
    | {
        /** Pre-select a status chip (e.g. Present, Absent, Late). */
        initialStatus?: string;
      }
    | undefined;
  /** Team Lead daily attendance register (assigned employees only). */
  TeamAttendanceReport:
    | {
        initialStatus?: string;
      }
    | undefined;
  MonthlyAttendanceReport: undefined;
  WeeklyAttendanceReport: undefined;
  EmployeeOverallWeeklyReport: undefined;
  EmployeeMonthlyAttendanceReport: undefined;
  WeeklyAttendanceEmployee: {
    employeeId: number;
    weekStart?: string;
    weekEnd?: string;
  };
  MyWeeklyAttendance: undefined;
  WfhReport: undefined;
  LeaveReport: undefined;
  OrganizationHome: undefined;
  OrganizationDetails: undefined;
  OrganizationEdit: undefined;
  OrganizationList: undefined;
  OrganizationCreate: undefined;
  OrganizationCreated: {
    organizationId: number;
    organizationCode: string;
    organizationName: string;
  };
  ManagedOrganizationDetails: { organizationId: number };
  OrganizationHrAdminCreate: { organizationId: number; organizationName: string };
  LocationList: undefined;
  LocationDetails: { locationId: number };
  LocationCreate: undefined;
  LocationEdit: { locationId: number };
  DepartmentList: undefined;
  DepartmentDetails: { departmentId: number };
  DepartmentCreate: undefined;
  DepartmentEdit: { departmentId: number };
  DesignationList: undefined;
  DesignationDetails: { designationId: number };
  DesignationCreate: undefined;
  DesignationEdit: { designationId: number };
  TeamList: undefined;
  TeamDetails: { teamId: number };
  TeamCreate: undefined;
  TeamEdit: { teamId: number };
  ShiftList: undefined;
  ShiftDetails: { shiftId: number };
  ShiftCreate: undefined;
  ShiftEdit: { shiftId: number };
  WorkPolicyList: undefined;
  WorkPolicyDetails: { workPolicyId: number };
  WorkPolicyCreate: undefined;
  WorkPolicyEdit: { workPolicyId: number };
  KioskList: undefined;
  KioskCreate: undefined;
  KioskDetails: { kioskId: number };
  KioskActivationQr: { kioskId: number };
  ProjectList: undefined;
  ProjectCreate: undefined;
  ProjectEdit: { projectId: number; projectName?: string };
  ProjectTaskBoard: { projectId: number; projectName?: string };
  ProjectTaskDetails: { projectId: number; taskId: number; projectName?: string };
  /** Task report for one opened project. */
  ProjectReport: { projectId: number; projectName?: string };
  VisitorList: undefined;
  VisitorRegister: undefined;
  VisitorCheckIn: undefined;
  VisitorCheckOut: undefined;
  VisitorHistory: undefined;
  OfficeCalendar:
    | {
        holidayCalendarId?: number;
        calendarName?: string;
      }
    | undefined;
  HolidayCalendarList: undefined;
  HolidayCalendarCreate: undefined;
  HolidayCalendarEdit: { holidayCalendarId: number };
};

export type AuthStackParamList = {
  Login: undefined;
  ForgotPassword: { loginName?: string } | undefined;
};

export type KioskStackParamList = {
  Kiosk: undefined;
  KioskActivation: undefined;
  Login: undefined;
  ForgotPassword: { loginName?: string } | undefined;
};

export type MainTabParamList = {
  Dashboard: undefined;
  AdminDashboard: undefined;
  /** Team Lead dashboard (assigned employees only). */
  TeamDashboard: undefined;
  /** Employee personal attendance home. */
  Attendance: undefined;
  /** Admin org-wide attendance register. */
  AttendanceReport:
    | {
        initialStatus?: string;
      }
    | undefined;
  Employees: undefined;
  /** Employee leave home, or admin leave requests when LEAVE_APPROVE. */
  Leave: undefined;
  /** Employee office holidays & working days calendar. */
  CalendarTab: undefined;
  Menu: undefined;
};
